import * as React from 'react';
import { Link } from 'react-router';
import { __ } from 'react-i18n/lib';
import { rem } from 'polished';
import { FlexRowCenterVertical, IconImg, prop, TextP } from '../../..';
import styled from 'styled-components';
import { resolveCategoryUrl } from '../../../utilities/selectors';
import { getImagePath } from '../../../utilities/product';

interface Props {
  categories: any;
  marginLeft: number;
}

function FavoriteCategory(props) {
  const { categories, marginLeft } = props;

  return (
    <ContentWrapper marginLeft={marginLeft}>
      <ProductTitleWrapper>
        <Title>{__('Obľúbené kategórie')}</Title>
      </ProductTitleWrapper>
      <FavouriteWrapper>
        {categories &&
          categories.map((item, key) => (
            <FavouriteCategory
              key={key}
              to={resolveCategoryUrl(
                item.redirect_category_id || item.category_id,
                prop(item, 'publish.0.url') || item.url || 'url',
                'CATEGORYTEXT/URL'
              )}
              draggable={false}
            >
              <FavouriteImage
                src={
                  item.image
                    ? getImagePath(item.image, { width: 64, height: 64 })
                    : '/images/icons/placeholder.svg'
                }
              />
              <FavouriteNameWrapper>
                <FavouriteName>
                  {prop(
                    item,
                    'publish.0.category_name',
                    prop(
                      item,
                      'content.0.name',
                      prop(item, 'category_name', ''),
                    ),
                  ) || item.category_name}
                </FavouriteName>
              </FavouriteNameWrapper>
            </FavouriteCategory>
          ))}
      </FavouriteWrapper>
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div<{ marginLeft?: number }>`
  margin-left: ${({ marginLeft }) => (marginLeft ? rem(marginLeft) : 0)};
  margin-top: ${rem(28)};
  margin-bottom: ${rem(28)};
  ${({ theme }) => theme.mediab.l1150`
     margin-left: 0;
  `}
`;

const FavouriteWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const FavouriteCategory = styled(Link)`
  text-decoration: none;
  width: 32%;
  padding: ${rem(24)} ${rem(30)};
  margin: 0 ${rem(16)} ${rem(16)} 0;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 4px #00000014;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  ${({ theme }) => theme.mediab.l1150`
     width: 31%;
  `}
  ${({ theme }) => theme.mediab.m760`
     flex-direction: column;
     justify-content: center;
     width: 49%;
     font-size: 14px;
     margin: 0 ${rem(8)} ${rem(8)} 0;
     &:nth-child(3n + 3) {
        margin-right: ${rem(8)};
     }
     &:nth-child(2n + 0) {
        margin-right: 0};
     }
  `}
  ${({ theme }) => theme.mediab.s450`
     width: 48%;
  `}
`;

const FavouriteImage = styled(IconImg)`
  width: 48px;
  height: 48px;
  margin-right: ${rem(16)};
  cursor: pointer;

  ${({ theme }) => theme.mediab.m760`
     margin: 0 auto;
  `}
`;

const FavouriteNameWrapper = styled.div`
  height: 48px;
  display: table;
  ${({ theme }) => theme.mediab.m760`
     width: 100%;
  `}
`;

const FavouriteName = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  display: table-cell;
  vertical-align: middle;
  ${({ theme }) => theme.mediab.m760`
     text-align: center;
  `}
  cursor: auto;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;
  cursor: pointer;
`;

export const ProductTitleWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.l1050`
     margin-bottom: ${rem(32)};
  `}
`;

export const Title = styled(TextP)`
  text-decoration: none;
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(38)};
  font-weight: 400;
  margin: 0;
`;

export { FavoriteCategory as DsiFavoriteCategory };
